import locale from "localization/en";

export const columns = [
  { key: "email", text: locale.emailAddress, width: "250px" },
  { key: "role", text: locale.accessType, width: "200px" },
  { key: "actions", text: locale.action, width: "100px" },
];
